// src/utils/helpers/getCreatedId.js

/**
 * Pull the new record's id out of a create call's `{ success, data }` result.
 * Services differ in how much of the response envelope they unwrap, so accept
 * both `data.<key>` and `data.data.<key>`. Returns null when not found.
 */
export function getCreatedId(result, key) {
  return result?.data?.[key] ?? result?.data?.data?.[key] ?? null;
}
